/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/namespace */
import InfoIcon from '@mui/icons-material/Info';
import {
  Grid,
  Skeleton,
  Stack,
  Tooltip,
  tooltipClasses,
  styled,
  TooltipProps
} from '@mui/material';
import _ from 'lodash';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks';
import './delist-sku-info.scss';
import { formatNumber } from '../../../pricing-simulator';
import {
  SummaryStrip,
  SummaryStripData
} from '../../../pricing-simulator/types/generic-table.model';

export default function DelistSkuInfo() {
  // app dispatch for dispatching actions for delist
  const appDispatch = useAppDispatch();
  const skeletonCount = new Array(2).fill(0);
  // getting state from sku delist reducer/slice
  const { skuTableMetaData, fetchingTableData } = useAppSelector(
    (state) => state.skuDelist
  );

  const summaryStripData = skuTableMetaData.summary_strip;

  const getValue = (key) => {
    const getMetricsInfo = summaryStripData.metadata.find(
      (metrics) => metrics.name === key
    );
    if (
      (key === 'internal_dt' || key === 'external_dt') &&
      summaryStripData.data.delist
    ) {
      return formatNumber(
        getMetricsInfo.number_format,
        summaryStripData.data[key]
      );
    }

    return summaryStripData.data.delist
      ? getMetricsInfo
        ? formatNumber(
          getMetricsInfo.number_format,
          summaryStripData.data.delist.value
        )
        : summaryStripData.data.delist.value
      : 0;
  };

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#F5F5F5',
      color: '#000000',
      padding: theme.spacing(2),
      boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)'
    }
  }));

  const getTooltipTemplate = (summaryData: {
    metadata: SummaryStrip[];
    data: SummaryStripData;
  }) => (
    <div style={{ fontSize: '12px', fontWeight: '400' }}>
      {summaryData.data.delist
        ? summaryData.data.delist.children.map((childEle) => (
          <div style={{ marginBottom: '5px' }}>
            <span>{childEle.label}: </span>
            <span>{childEle.value}</span>
          </div>
        ))
        : 'No delisted items'}
    </div>
  );

  return (
    <div>
      {fetchingTableData && (
        <Grid container spacing={1} mt={1}>
          {skeletonCount.map((e) => (
            <Grid item md={3}>
              <Stack spacing={1}>
                <Skeleton
                  animation='wave'
                  variant='rectangular'
                  width='100%'
                  height={25}
                />
              </Stack>
            </Grid>
          ))}
        </Grid>
      )}
      {!fetchingTableData && (
        <div className='info-box-div'>
          <div className='info-box info-box-label sku-delist-label-container'>
            <span style={{ display: 'inline-block', width: '130px' }}>
              SKU's Delisted:
              <span className='info-value'>{getValue('n_delisted')}</span>
            </span>
            <HtmlTooltip
              title={getTooltipTemplate(summaryStripData)}
              arrow
              placement='right'
            >
              <span className='info-icon-container'>
                <InfoIcon className='sku-info-icon' />
              </span>
            </HtmlTooltip>
          </div>
        </div>
      )}
    </div>
  );
}
